<template>
  <div class="riepilogo-trasferte">

    <transition name="fade">
      <ricerca v-show="showSearchPanel" @closeRicerca="closeSearch" @cerca="cerca" @loadingOff="setLoading(false)"
        :tipoRicerca="'Trasferte_form'">
      </ricerca>

    </transition>


    <div class="WEB-actions col-24 no-padding">
      <el-button class="WEB-button WEB-button-header left filtri" @click="openSearch">
        <div class="filtri-div">
          <div class="icon-left">
            <icon name="riv-filter" scale="1.4"></icon>
          </div>
          <div class="label">{{ $t('btn.filtri') }}</div>
          <div style="width: 20px"></div>
        </div>
      </el-button>
      <el-button class="WEB-button WEB-button-primary right" @click="add(null)">
        {{ $t('btn.nuova').toUpperCase() }}
      </el-button>
    </div>

    <el-table :data="listaTrasferte" row-class-name="single riga-hover" @sort-change="sortChange" row-key="idTrasferta"
      @row-click="dettTrasferta" :empty-text="$t('trasferte.msg.noData')" v-loading="loading"
      class="custom-table table-trasferte" :height="100 % - 56 - 50 - 50 - 60 - 5">

      <el-table-column width="70">

        <template slot-scope="scope" slot="header">
          <div class="icon-title">
            <el-popover placement="top" trigger="click" :key="scope.toString()">
              <div>
                <div>
                  <icon :name="getStatoIcon('0')" class="status-saved" scale="1"></icon>
                  <span>{{ $t('status.0') }}</span>
                </div>
                <div>
                  <icon :name="getStatoIcon('1')" class="status-send" scale="1"></icon>
                  <span>{{ $t('status.1') }}</span>
                </div>
                <div>
                  <icon :name="getStatoIcon('2')" class="status-rejected" scale="1"></icon>
                  <span>{{ $t('status.2') }}</span>
                </div>
                <div>
                  <icon :name="getStatoIcon('3')" class="status-approved" scale="1"></icon>
                  <span>{{ $t('status.3') }}</span>
                </div>
                <div>
                  <icon :name="getStatoIcon('4')" class="status-send" scale="1"></icon>
                  <span>{{ $t('status.4') }}</span>
                </div>
                <div>
                  <icon :name="getStatoIcon('4')" class="status-approved" scale="1"></icon>
                  <span>{{ $t('status.3') }}</span>
                </div>
                <div>
                  <icon :name="getStatoIcon('7')" class="status-delete" scale="1"></icon>
                  <span>{{ $t('status.7') }}</span>
                </div>
              </div>
              <span slot="reference">
                <icon class="pointer" name="riv-help" scale="1"></icon>
              </span>
            </el-popover>

          </div>
        </template>

        <template slot-scope="scope">
          <div class="name-wrapper">
            <el-tooltip class="item" effect="dark" :content="$t(getStatoDes(scope.row))" placement="top-start">
              <icon :name="getStatoIcon(scope.row.statoAvanz)" :class="getStatoClass(scope.row)" scale="1.1"></icon>
            </el-tooltip>
          </div>
        </template>

      </el-table-column>

      
      <el-table-column header-align="center" align="center" prop="dataIn" :label="$t('trasferte.periodo')"
        sortable="custom" width="160">

        <template slot-scope="scope">
          <div class="name-wrapper">
            {{ formatPeriodo(scope.row) }}
          </div>
        </template>

      </el-table-column>

      <el-table-column header-align="center" align="center" prop="dataIn" :label="$t('trasferte.numOre')"
        sortable="custom" width="120">

        <template slot-scope="scope">
          <div class="name-wrapper">
            {{ scope.row.tipoTrasferta === 'ORE' ? scope.row.oreTrasferta : ''}}
          </div>
        </template>

      </el-table-column>

      <!--<el-table-column header-align="center" align="center" prop="dataIn" :label="$t('trasferte.label.dataIn')"
        sortable="custom" width="120">

        <template slot-scope="scope">
          <div class="name-wrapper">
            {{ scope.row.dataDal | formattaData }}
          </div>
        </template>

      </el-table-column>

      <el-table-column header-align="center" align="center" prop="dataFin" :label="$t('trasferte.label.dataFin')"
        sortable="custom" width="120">

        <template slot-scope="scope">
          <div class="name-wrapper">
            {{ scope.row.dataAl | formattaData }}
          </div>
        </template>

      </el-table-column>-->
      <el-table-column header-align="center" align="center" :label="$t('trasferte.label.destinazione')">

        <template slot-scope="scope">
          <div class="name-wrapper">
            {{ scope.row.desDest === undefined ? scope.row.desMan : scope.row.desDest }}
          </div>
        </template>

      </el-table-column>
      <el-table-column header-align="center" align="center" :label="$t('trasferte.label.soc')">

        <template slot-scope="scope">
          <div class="name-wrapper">
            {{ scope.row.desCli }}
          </div>
        </template>

      </el-table-column>

      <el-table-column width="50">

        <template slot-scope="scope">
          <div class="actions">
            <el-tooltip class="item" effect="dark" :content="$t('trasferte.label.riepilogo')" placement="top-start"
              :open-delay="1000">
              <icon class="pointer" name="riv-more" scale="1.1" @click.native.stop="dettaglio(scope.row)"></icon>
            </el-tooltip>
          </div>
        </template>
      </el-table-column>

      <el-table-column width="50">

        <template slot-scope="scope">
          <div class="actions">
            <el-tooltip class="item" effect="dark" :content="$t('trasferte.label.nuova')" placement="top-start"
              :open-delay="1000">
              <icon class="pointer" name="riv-paste" scale="1.1" @click.native.stop="add(scope.row)"></icon>
            </el-tooltip>
          </div>
        </template>
      </el-table-column>

      <el-table-column width="50">

        <template slot-scope="scope">
          <div class="actions">
            <el-tooltip class="item" effect="dark" :content="$t('trasferte.label.copia')" placement="top-start"
              :open-delay="1000">
              <icon class="pointer" name="riv-copy" scale="1.1" @click.native.stop="copia(scope.row)"></icon>
            </el-tooltip>
          </div>
        </template>
      </el-table-column>

      <el-table-column width="50">

        <template slot-scope="scope">
          <div class="actions">
            <el-tooltip class="item" effect="dark" :content="$t('btn.elimina')" placement="top-start"
              :open-delay="1000">
              <icon class="pointer" name="riv-delete2" scale="1.1" @click.native.stop="elimina(scope.row)"></icon>
            </el-tooltip>
          </div>
        </template>
      </el-table-column>

    </el-table>

    <el-pagination v-if="(nrPages > 1)" :current-page="currentPage" class="custom-pagination" background
      layout="prev, pager, next" :total="nrItems" :page-size="pag_for" @current-change="changePage">
    </el-pagination>

    <!-- Dialog di dettaglio trasferta -->
    <el-dialog :title="($t('trasferte.label.riepilogo').toUpperCase())" :visible.sync="showModalDettaglio"
      class="custom-dialog" :append-to-body="true" custom-class="offset-5 col-14">

      <el-table :data="dettaglioTrasferta" @sort-change="sortChange" width="100%" class="custom-table"
        :style="{ height: (tableHeight - 167) + 'px' }" highlight-current-row>


        <el-table-column width="100">

          <template slot-scope="scope">
            <div class="name-wrapper">
              {{ scope.row.giorno | formattaData }}
            </div>
          </template>

        </el-table-column>

        <el-table-column header-align="center" align="center" class-name="icona" :label="$t('trasferte.label.mensa')"
          min-width="100">

          <template slot-scope="scope">
            <div class="name-wrapper">
              <el-tooltip v-if="scope.row.statoMensa !== ''" class="item" effect="dark"
                :content="$t('statusDett.' + scope.row.statoMensa)" placement="top-start">
                <icon :name="getStatoIcon_dett(scope.row.statoMensa)" :class="getStatoClass_dett(scope.row.statoMensa)"
                  scale="0.8"></icon>
              </el-tooltip>
            </div>
          </template>

        </el-table-column>

        <el-table-column header-align="center" align="center" class-name="icona" :label="$t('trasferte.label.alloggio')"
          min-width="100">

          <template slot-scope="scope">
            <div class="name-wrapper">
              <el-tooltip v-if="scope.row.statoAlloggio !== ''" class="item" effect="dark"
                :content="$t('statusDett.' + scope.row.statoAlloggio)" placement="top-start">
                <icon :name="getStatoIcon_dett(scope.row.statoAlloggio)"
                  :class="getStatoClass_dett(scope.row.statoAlloggio)" scale="0.8"></icon>
              </el-tooltip>
            </div>
          </template>

        </el-table-column>

        <el-table-column header-align="center" align="center" class-name="icona"
          :label="$t('trasferte.label.biglietto')" min-width="100">

          <template slot-scope="scope">
            <div class="name-wrapper">
              <el-tooltip v-if="scope.row.statoBiglietti !== ''" class="item" effect="dark"
                :content="$t('statusDett.' + scope.row.statoBiglietti)" placement="top-start">
                <icon :name="getStatoIcon_dett(scope.row.statoBiglietti)"
                  :class="getStatoClass_dett(scope.row.statoBiglietti)" scale="0.8"></icon>
              </el-tooltip>
            </div>
          </template>

        </el-table-column>

        <el-table-column header-align="center" align="center" class-name="icona"
          :label="$t('trasferte.label.trasporto')" min-width="100">

          <template slot-scope="scope">
            <div class="name-wrapper">
              <el-tooltip v-if="scope.row.statoTrasporti !== ''" class="item" effect="dark"
                :content="$t('statusDett.' + scope.row.statoTrasporti)" placement="top-start">
                <icon :name="getStatoIcon_dett(scope.row.statoTrasporti)"
                  :class="getStatoClass_dett(scope.row.statoTrasporti)" scale="0.8"></icon>
              </el-tooltip>
            </div>
          </template>

        </el-table-column>

        <el-table-column header-align="center" align="center" class-name="icona" :label="$t('trasferte.label.auto')"
          min-width="100">

          <template slot-scope="scope">
            <div class="name-wrapper">
              <el-tooltip v-if="scope.row.statoAutoAz !== ''" class="item" effect="dark"
                :content="$t('statusDett.' + scope.row.statoAutoAz)" placement="top-start">
                <icon :name="getStatoIcon_dett(scope.row.statoAutoAz)"
                  :class="getStatoClass_dett(scope.row.statoAutoAz)" scale="0.8"></icon>
              </el-tooltip>
            </div>
          </template>

        </el-table-column>


      </el-table>

      <span slot="footer" class="dialog-footer">
        <el-button class="WEB-button WEB-button-alternative" @click="showModalDettaglio = false">{{ $t('btn.annulla')
          }}</el-button>
      </span>

    </el-dialog>

    <!-- Dialog per la copia trasferta -->
    <el-dialog :title="($t('trasferte.label.copia').toUpperCase())" :visible.sync="showModalCopia" class="custom-dialog"
      :append-to-body="true" custom-class="offset-5 col-14" :close-on-click-modal="false">


      <el-form class="">
        <div class="elemento row row-custom">
          <div class="my-label col-8 no-padding">
            {{ $t('trasferte.tipoTrasferta') }}
          </div>
          <div class="my-value col-16 no-padding">
            <el-select v-model="trasferta.tipoTrasferta" disabled>
              <el-option v-for="item in tbl_tipoTrasferta" :key="item.id" :label="item.desc" :value="item.id">
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="elemento row row-custom" v-if="trasferta.tipoTrasferta === 'ORE'">
          <div class="my-label col-8 no-padding">
            {{ $t('trasferte.orario') }}
          </div>
          <div class="my-value col-4 no-padding">
            <el-time-select disabled v-model="trasferta.oraIni" :picker-options="{
              start: '00:00',
              step: timeStep,
              end: '24:00'
            }" placeholder="">
            </el-time-select>
          </div>
          <div class="col-1 no-padding" style="text-align: center">
            {{ $t('trasferte.to') }}
          </div>
          <div class="my-value col-4 no-padding">
            <el-time-select disabled v-model="trasferta.oraFin" :picker-options="{
              start: '00:00',
              step: timeStep,
              end: '24:00'
            }" placeholder="">
            </el-time-select>
          </div>
          <div class="my-label col-3 no-padding" style="text-align: center">
            {{ $t('trasferte.numOre') }}
          </div>
          <div class="my-value col-4 no-padding">
            <el-time-select disabled v-model="trasferta.oreTrasferta"
              :picker-options="{
                start: '00:00',
                step: timeStep,
                end: '24:00'
              }" placeholder="">
            </el-time-select>
          </div>
        </div>
        <div class="elemento row row-custom">
          <div class="my-label col-8 no-padding">
            {{ $t('trasferte.label.giornoCopia') }}
          </div>
          <div class="my-value col-16 no-padding">
            <el-date-picker class="dt-picker" v-model="trasferta.giorno" type="date" format="dd/MM/yyyy"
              value-format="yyyyMMdd" placeholder="" :picker-options="{
                firstDayOfWeek: 1
              }">
            </el-date-picker>
          </div>
        </div>
        <div class="elemento row row-custom">
          <div class="my-label col-8 no-padding">
            {{ $t('trasferte.label.referente') }}
          </div>
          <div class="my-value col-16 no-padding">
            <el-select v-model="select_mail" :placeholder="$t('trasferte.label.selMail')" filterable
              :filter-method="listEmail" @change="selectEmail">
              <el-option v-for="item in tbl_mail" :key="item.Email"
                :label="item.Surname + ' ' + item.Name + ' ' + item.Email" :value="item.Email">
              </el-option>
            </el-select>
            <!--<el-input placeholder="" v-model="trasferta.perRif">
            </el-input>-->
          </div>
        </div>
        <div class="elemento row row-custom">
          <div class="my-label col-8 no-padding">
          </div>
          <div class="my-value col-16 no-padding">
            <el-input :placeholder="$t('trasferte.label.insertMail')" v-model="manualMail" style="width: 90%;"
              :input="changeInput('mail')" :class="[this.check.manualMail ? '' : 'input-error']">
            </el-input>
            <!--<el-input :placeholder="$t('trasferte.label.nome')" v-model="manualNome" style="width: 45%;" :input="changeInput('nome')" :class="[this.check.manualNome ? '' : 'input-error']">
            </el-input>-->
            <div class="add pointer" @click="addEmail({ 'nome': '', 'mail': manualMail })">
              <icon name="riv-add_2" scale="1"></icon>
            </div>
          </div>
        </div>
        <div class="elemento row row-custom">
          <div class="my-label col-8 no-padding">
          </div>
          <div class="my-value col-16 no-padding">
            <el-tag :key="tag.mail" v-for="tag in trasferta.contatti" closable :disable-transitions="false"
              @close="handleClose(tag)">
              {{ tag.mail }}
            </el-tag>

          </div>
        </div>
        <div class="elemento row row-custom">
          <div class="my-label col-8 no-padding">
            {{ $t('trasferte.label.motivo') }}
          </div>
          <div class="my-value col-16 no-padding">
            <el-input placeholder="" v-model="trasferta.notaDip" type="textarea"
              :autosize="{ minRows: 6, maxRows: 10 }">
            </el-input>
          </div>
        </div>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button class="WEB-button WEB-button-alternative" @click="showModalCopia = false">{{ $t('btn.annulla')
          }}</el-button>
        <el-button class="WEB-button WEB-button-primary" @click="incolla">{{ $t('btn.salva').toUpperCase()
          }}</el-button>
      </span>

    </el-dialog>


    <!-- Dialog per la creazione di una nuova trasferta -->
    <el-dialog :title="($t('trasferte.label.nuova').toUpperCase())" :visible.sync="showModalNew" class="custom-dialog"
      :append-to-body="true" custom-class="offset-5 col-14" :close-on-click-modal="false">

      <el-form class="">

        <div class="elemento row row-custom">
           <div class="my-label col-8 no-padding">
            {{ $t('trasferte.tipoTrasferta') }}
          </div>
          <div class="my-value col-16 no-padding">
            <el-select v-model="trasferta.tipoTrasferta" filterable>
              <el-option v-for="item in tbl_tipoTrasferta" :key="item.id" :label="item.desc" :value="item.id">
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="elemento row row-custom" v-if="trasferta.tipoTrasferta === 'GIO'">
          <div class="my-label col-8 no-padding">
            {{ $t('trasferte.periodo') }}
          </div>
          <div class="my-value col-16 no-padding">
            <el-date-picker class="dt-picker" v-model="trasferta.periodo" type="daterange"
              :range-separator="$t('placeholder.rangeSeparator')" :start-placeholder="$t('placeholder.startDate')"
              :end-placeholder="$t('placeholder.endDate')" format="dd/MM/yyyy" value-format="yyyyMMdd" :picker-options="{
                firstDayOfWeek: 1
              }">
            </el-date-picker>

            <!--<el-date-picker class="dt-picker"
                            v-model="trasferta.dataDa"
                            type="date" format="dd/MM/yyyy" value-format="yyyyMMdd"
                            placeholder=""
                            :picker-options="{
                                  firstDayOfWeek: 1
                                }">
            </el-date-picker>
            <el-date-picker class="dt-picker"
                            v-model="trasferta.dataAl"
                            type="date" format="dd/MM/yyyy" value-format="yyyyMMdd"
                            placeholder=""
                            :picker-options="{
                                  firstDayOfWeek: 1
                                }">
            </el-date-picker>-->
          </div>
        </div>
        <div class="elemento row row-custom" v-else>
          <div class="my-label col-8 no-padding">
            {{ $t('trasferte.label.giorno') }}
          </div>
          <div class="my-value col-16 no-padding">
            <el-date-picker class="dt-picker"
                            v-model="trasferta.dataDal"
                            type="date" format="dd/MM/yyyy" value-format="yyyyMMdd"
                            placeholder=""
                            :picker-options="{
                                  firstDayOfWeek: 1
                                }">
            </el-date-picker>
          </div>
        </div>
        <div class="elemento row row-custom" v-if="trasferta.tipoTrasferta === 'ORE'">
          <div class="my-label col-8 no-padding">
            {{ $t('trasferte.orario') }}
          </div>
          <div class="my-value col-4 no-padding">
            <el-time-select @change="changeOre" v-model="trasferta.oraIni" :picker-options="{
              start: '00:00',
              step: timeStep,
              end: '24:00'
            }" placeholder="">
            </el-time-select>
          </div>
          <div class="col-1 no-padding" style="text-align: center">
            {{ $t('trasferte.to') }}
          </div>
          <div class="my-value col-4 no-padding">
            <el-time-select @change="changeOre" v-model="trasferta.oraFin" :picker-options="{
              start: '00:00',
              step: timeStep,
              end: '24:00'
            }" placeholder="">
            </el-time-select>
          </div>
          <div class="my-label col-3 no-padding" style="text-align: center">
            {{ $t('trasferte.numOre') }}
          </div>
          <div class="my-value col-4 no-padding">
            <el-time-select v-model="trasferta.oreTrasferta"
              :picker-options="{
                start: '00:00',
                step: timeStep,
                end: '24:00'
              }" placeholder="">
            </el-time-select>
          </div>
        </div>

        <div class="elemento row row-custom">
          <div class="my-label col-8 no-padding">
            {{ $t('trasferte.label.partenza') }}
          </div>
          <div class="my-value col-16 no-padding">
            <el-select v-model="trasferta.partenza" filterable>
              <el-option v-for="item in tbl_genSta" :key="item.id" :label="item.desc" :value="item.id">
              </el-option>
            </el-select>
          </div>
        </div>

        <div class="elemento row row-custom">
          <div class="my-label col-8 no-padding">
            {{ $t('trasferte.label.destinazione') }}
          </div>
          <div class="my-value no-padding" :class="this.flagDestinazioniEstere ? 'col-10' : 'col-16'">
            <el-select v-model="trasferta.destinazione" filterable allow-create @change="changeDestinazione()">
              <el-option v-for="item in tbl_genSta" :key="item.id" :label="item.desc" :value="item.id">
              </el-option>
            </el-select>
          </div>
          <div class="my-value col-6 no-padding check-estera" v-show="this.flagDestinazioniEstere">
            <span class="check-estera-label">{{ $t('trasferte.label.estera') }}</span><el-checkbox
              v-model="trasferta.seEstero"></el-checkbox>
          </div>
        </div>

        <div class="elemento row row-custom">
          <div class="my-label col-8 no-padding">
            {{ $t('trasferte.label.soc') }}
          </div>
          <div class="my-value col-16 no-padding">
            <el-select v-model="trasferta.socFat" @change="loadUffRep" filterable>
              <el-option v-for="item in tbl_genStaFat" :key="item.id" :label="item.desc" :value="item.id">
              </el-option>
            </el-select>
          </div>
        </div>

        <div class="elemento row row-custom">
          <div class="my-label col-8 no-padding">
            {{ $t('trasferte.label.uffRep') }}
          </div>
          <div class="my-value col-16 no-padding">
            <el-select v-model="trasferta.uffRep" filterable>
              <el-option v-for="item in tbl_uffRep" :key="item.id" :label="item.desc" :value="item.id">
              </el-option>
            </el-select>
          </div>
        </div>


        <div class="elemento row row-custom">
          <div class="my-label col-8 no-padding">
            {{ $t('trasferte.label.referente') }}
          </div>
          <div class="my-value col-16 no-padding">
            <el-select v-model="select_mail" :placeholder="$t('trasferte.label.selMail')" filterable
              :filter-method="listEmail" @change="selectEmail">
              <el-option v-for="item in tbl_mail" :key="item.Email"
                :label="item.Surname + ' ' + item.Name + ' ' + item.Email" :value="item.Email">
              </el-option>
            </el-select>
            <!--<el-input placeholder="" v-model="trasferta.perRif">
            </el-input>-->
          </div>
        </div>
        <div class="elemento row row-custom">
          <div class="my-label col-8 no-padding">
          </div>
          <div class="my-value col-16 no-padding">
            <el-input :placeholder="$t('trasferte.label.insertMail')" v-model="manualMail" style="width: 90%;"
              :input="changeInput('mail')" :class="[this.check.manualMail ? '' : 'input-error']">
            </el-input>
            <!--<el-input :placeholder="$t('trasferte.label.nome')" v-model="manualNome" style="width: 45%;" :input="changeInput('nome')" :class="[this.check.manualNome ? '' : 'input-error']">
            </el-input>-->
            <div class="add pointer" @click="addEmail({ 'nome': '', 'mail': manualMail })">
              <icon name="riv-add_2" scale="1"></icon>
            </div>
          </div>
        </div>
        <div class="elemento row row-custom">
          <div class="my-label col-8 no-padding">
          </div>
          <div class="my-value col-16 no-padding">
            <el-tag :key="tag.mail" v-for="tag in trasferta.contatti" closable :disable-transitions="false"
              @close="handleClose(tag)">
              {{ tag.mail }}
            </el-tag>

          </div>
        </div>

        <div class="elemento row row-custom">
          <div class="my-label col-8 no-padding">
            {{ $t('trasferte.label.motivo') }}
          </div>
          <div class="my-value col-16 no-padding">
            <el-input placeholder="" v-model="trasferta.notaDip" type="textarea" :autosize="{ minRows: 4, maxRows: 6 }">
            </el-input>
          </div>
        </div>

        <div class="elemento row row-custom">
          <div class="my-label col-8 no-padding">
            {{ $t('trasferte.label.mensa') }}
          </div>
          <div class="my-value col-16 no-padding">
            <el-checkbox v-model="trasferta.checkedMensa" :indeterminate="false"
              class="riva-header-checkbox"></el-checkbox>
            <el-input placeholder="" v-model="trasferta.notaMensa" :disabled="!trasferta.checkedMensa"
              style="width: calc(100% - 35px);float: right;"></el-input>
          </div>
        </div>

        <div class="elemento row row-custom" v-if="trasferta.tipoTrasferta === 'GIO'">
          <div class="my-label col-8 no-padding">
            {{ $t('trasferte.label.alloggio') }}
          </div>
          <div class="my-value col-16 no-padding">
            <el-checkbox v-model="trasferta.checkedAlloggio" :indeterminate="false"
              class="riva-header-checkbox"></el-checkbox>
            <el-input placeholder="" v-model="trasferta.notaAlloggio" :disabled="!trasferta.checkedAlloggio"
              style="width: calc(100% - 35px);float: right;">
            </el-input>
          </div>
        </div>

      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button class="WEB-button WEB-button-alternative" @click="showModalNew = false">{{ $t('btn.annulla')
          }}</el-button>
        <el-button class="WEB-button WEB-button-primary" @click="salva">{{ $t('btn.salva').toUpperCase() }}</el-button>
      </span>

    </el-dialog>

  </div>
</template>
<script>
import Ricerca from './Ricerca.vue'
import { bus } from '../Bus.js'
import moment from 'moment'

export default {
  components: { Ricerca },
  name: 'RiepilogoTrasferte',
  props: ['tableHeight'],
  i18n: {
    messages: {
      it_IT: {
        trasferte: {
          label: {
            title: 'Trasferta',
            periodo: 'Periodo',
            dataIn: 'Data Inizio',
            dataFin: 'Data Fine',
            partenza: 'Partenza',
            destinazione: 'Destinazione',
            soc: 'Per Conto della Società',
            uffRep: 'Ufficio/Reparto',
            referente: 'Persona di Riferimento',
            motivo: 'Motivo',
            mensa: 'Mensa',
            alloggio: 'Alloggio',
            biglietto: 'Biglietto',
            trasporto: 'Trasporto',
            auto: 'auto Società',
            giorno: 'Giorno',
            nuova: 'Nuova Trasferta',
            riepilogo: 'Riepilogo Viaggio',
            copia: 'Copia Trasferta',
            giornoCopia: 'Giorno Inizio Trasferta',
            estera: 'Località Estera?',
            mail: 'E-mail',
            nome: 'Nome',
            selMail: 'Ricerca e-mail tra il personale Riva',
            insertMail: 'Aggiungi un indirizzo email esterno'
          },
          msg: {
            confDelTrasferta: 'Sei sicuro di voler eliminare la Trasferta?',
            info: 'Avviso!',
            abort: 'Operazione Annullata',
            noData: 'Nessun Documento trovato',
            errorNoPeriodo: 'Inserire il periodo della Trasferta'
          }
        }
      },
      fr_FR: {
        trasferte: {
          label: {
            title: 'Deplacement',
            periodo: 'Date du-au',
            dataIn: 'Date du',
            dataFin: 'Date au',
            partenza: 'Départ',
            destinazione: 'Destination',
            soc: 'pour le compte de',
            referente: 'Personne de référence',
            uffRep: 'Bureau/département',
            motivo: 'Motif',
            mensa: 'Repas',
            alloggio: 'Hébergement',
            biglietto: 'Billets Voyage',
            trasporto: 'Transport',
            auto: 'Voiture de société',
            giorno: 'Jour',
            nuova: 'Nouveau déplacement',
            riepilogo: 'Résumé du Voyage',
            copia: 'Copier Déplacement',
            giornoCopia: 'Jour de départ',
            estera: 'à l\'étranger?',
            mail: 'E-mail',
            nome: 'Nom',
            selMail: 'Recherche d\'e-mails parmi le personnel de Riva',
            insertMail: 'Ajouter une adresse e-mail externe'
          },
          msg: {
            confDelTrasferta: 'Confirmer l\'élimination?',
            info: 'Info!',
            abort: 'Opération annulée',
            noData: 'Aucun document trouvé',
            errorNoPeriodo: 'Saisir la periode du déplacement',
          }
        }
      },
      es_ES: {
        trasferte: {
          label: {
            title: 'Viaje',
            periodo: 'Fecha desde-hasta',
            dataIn: 'Dia salida',
            dataFin: 'Dia regreso',
            partenza: 'Salida',
            destinazione: 'Destino',
            soc: 'Por cuenta de la sociedad',
            referente: 'Persona de referencia',
            uffRep: 'Oficina/Empresa',
            motivo: 'Referencia',
            mensa: 'Comedor',
            alloggio: 'Alojamiento',
            biglietto: 'Ticket',
            trasporto: 'Transporte',
            auto: 'Coche de La Sociedad',
            giorno: 'Día',
            nuova: 'Nuevo',
            riepilogo: 'Resumen Viaje',
            copia: 'Copia de viaje',
            giornoCopia: 'Dia inicio viaje',
            estera: 'En el extranjero?',
            mail: 'E-mail',
            nome: 'Nombre',
            selMail: 'Búsqueda de correo electrónico entre el personal de Riva',
            insertMail: 'Agregar una dirección de correo electrónico externa'
          },
          msg: {
            confDelTrasferta: '¿Está seguro que quiere eliminar la solicitud de viaje?',
            info: '¡Aviso!',
            abort: 'Operación cancelada',
            noData: 'Sin informacion',
            errorNoPeriodo: 'Añadir periodo del viaje',
          }
        }
      },
      de_DE: {
        trasferte: {
          label: {
            title: 'Dienstreise',
            periodo: 'Datum von-bis',
            dataIn: 'Reisebeginn',
            dataFin: 'Reiseende',
            partenza: 'Abreiseort',
            destinazione: 'Reiseziel',
            soc: 'auf Kosten der Firma',
            uffRep: 'Büro/Abteilung',
            referente: 'Ansprechpartner',
            motivo: 'Grund',
            mensa: 'Kantine',
            alloggio: 'Unterkunft',
            biglietto: 'Ticket',
            trasporto: 'Transport',
            auto: 'Firmenfahrzeug',
            giorno: 'Tag',
            nuova: 'Neue Reise',
            riepilogo: 'Zusammenfassung',
            copia: 'Kopie der Trasferta',
            giornoCopia: 'Reisebeginn',
            estera: 'Im Ausland?',
            mail: 'E-mail',
            nome: 'Name',
            selMail: 'E-Mail von Riva-Mitarbeitern suchen',
            insertMail: 'Externe E-Mail-Adresse hinzufügen'
          },
          msg: {
            confDelTrasferta: 'Sind Sie sicher, dass Sie den Reiseantrag löschen möchten?',
            info: 'Beachten!',
            abort: 'Operation abgebrochen',
            noData: 'Kein Dokument gefunden',
            errorNoPeriodo: 'Geben Sie den Reisezeitraum ein',
          }
        }
      },
      en_GB: {
        trasferte: {}
      }
    }
  },
  data() {
    return {
      moment: moment,
      visibleInfo: false,
      loading: false,
      showSearchPanel: false,
      showModalDettaglio: false,
      showModalCopia: false,
      showModalNew: false,
      form: {
        dataIn: '',
        dataFin: '',
        statoAvanz: '',
        destinazione: ''
      },
      listaTrasferte: [],
      dettaglioTrasferta: [],
      nrPages: 0,
      nrItems: 0,
      currentPage: 1,
      pag_for: 40,
      ordine: 'DD',
      /*formCopy: {
        idTrasferta: '',
        giorno: '',
        perRif: '',
        notaDip: ''
      },*/
      tbl_genSta: [],
      tbl_genStaFat: [],
      //tbl_socFat: [],
      tbl_uffRep: [],
      trasferta: {},
      flagDestinazioniEstere: false,
      tbl_mail: [],
      select_mail: '',
      //manualNome: '',
      manualMail: '',
      check: {
        //manualNome: true,
        manualMail: true
      },
      tbl_tipoTrasferta:[],
      timeStep: ''
    }
  },
  filters: {
    /* Formatta la data: GGMMAAAA --> GG/MM/AAAA */
    formattaData: function (date) {
      if (date !== '') {
        return date.substr(6, 2) + '/' + date.substr(4, 2) + '/' + date.substr(0, 4)
      } else {
        return ' '
      }
    }
  },
  mounted: function () {
    //this.$emit('setShowNuovo', true)
    //this.initialize()
  },
  activated: function () {
    this.initialize()
  },
  methods: {
    initialize: function () {
      this.$nextTick(() => {
        if (sessionStorage.hasOwnProperty('Trasferte_form')) {
          this.$set(this, 'form', JSON.parse(sessionStorage.getItem('Trasferte_form')))
          //this.ricerca(false)
        }
        this.loadGenSta()
        this.loadGenStaFat()
        this.timeStep = '00:30' // this.country === '1' ? '00:30' : '00:05'
        this.tbl_tipoTrasferta = [
          { id: 'GIO', desc: this.$i18n.t('trasferte.tipoGio') },
          { id: 'ORE', desc: this.$i18n.t('trasferte.tipoOre') }
        ]
        //this.loadSocfat()
        this.ricerca(false)
      })
    },
    loadGenSta: function () {
      this.$http.get('datisoc/' + this.$store.state.country + '/gensta')
        .then(response => {
          if (response.body.rc === 0) {
            this.tbl_genSta = response.body.data
          } else {
            this.$message({
              showClose: true,
              message: response.body.msg[0].msgTxt,
              type: 'error',
              duration: process.env.duration
            })
          }
        })
    },
    loadGenStaFat: function () {
      this.$http.get('datisoc/' + this.$store.state.country + '/gensta', {
        params: {
          socFat: 'Y'
        }
      }).then(response => {
        if (response.body.rc === 0) {
          this.tbl_genStaFat = response.body.data
        } else {
          this.$message({
            showClose: true,
            message: response.body.msg[0].msgTxt,
            type: 'error',
            duration: process.env.duration
          })
        }
      })
    },
    /*loadSocfat: function () {
      this.$http.get('datisoc/' + this.$store.state.country + '/socfat')
        .then(response => {
          if (response.body.rc === 0) {
            this.tbl_socFat = response.body.data
          } else {
            this.$message({
              showClose: true,
              message: response.body.msg[0].msgTxt,
              type: 'error',
              duration: process.env.duration
            })
          }
        })
    },*/
    loadUffRep: function (value) {
      //this.trasferta.uffRep = ''
      //this.trasferta.uffRep = ''
      delete this.trasferta['uffRep']
      this.$http.get('datisoc/' + this.$store.state.country + '/uffrep', {
        params: {
          cliente: value
        }
      }).then(response => {
        if (response.body.rc === 0) {
          this.tbl_uffRep = response.body.data
        } else {
          this.$message({
            showClose: true,
            message: response.body.msg[0].msgTxt,
            type: 'error',
            duration: process.env.duration
          })
        }
      })
    },
    closeSearch: function () {
      this.$emit('showScroll')
      this.showSearchPanel = false
    },
    openSearch: function () {
      this.showSearchPanel = true
      this.$emit('hideScroll')
    },
    cerca: function (form) {
      let formRicerca = JSON.parse(form)
      this.$set(this, 'form', formRicerca)
      this.currentPage = 1
      this.ricerca(false)
    },
    ricerca: function (flagIfChangeSort) {

      this.loading = true
      if (flagIfChangeSort === true) {
        this.$set(this, 'form', JSON.parse(sessionStorage.getItem('Trasferte_form')))
        this.currentPage = 1
      }
      let numStatiAvanz = ''
      let statoAvanz = ''
      if (this.form.statoAvanz == '' || this.form.statoAvanz == 'all') {
        statoAvanz = ''
        numStatiAvanz = "0"
      } else {
        statoAvanz = this.form.statoAvanz
        numStatiAvanz = "1"
      }
      sessionStorage.setItem('Trasferte_form', JSON.stringify(this.form))
      this.$http.get('trasferte/' + this.$store.state.country + '/trasferte', {
        params: {
          dataDal: this.form.dataDal,
          dataAl: this.form.dataAl,
          statoAvanz: statoAvanz,
          numStatiAvanz: numStatiAvanz,
          destinazione: this.form.destinazione,
          pag_action: (this.currentPage > 1) ? 'NEXT' : 'BEGIN',
          pag_from: this.currentPage,
          pag_for: this.pag_for,
          pag_order: this.ordine
        }
      })
        .then(response => {
          if (response.body.rc === 0) {
            sessionStorage.setItem('Trasferte_form', JSON.stringify(this.form))
            this.listaTrasferte = response.body.data
            if (this.currentPage === 1) {
              this.$set(this, 'nrPages', parseInt(response.body.attrib.pages))
              this.$set(this, 'nrItems', parseInt(response.body.attrib.size))
            }
          } else {
            this.$message({
              showClose: true,
              message: response.body.msg[0].msgTxt,
              type: 'error',
              duration: process.env.duration
            })
            this.$set(this, 'listaTrasferte', [])
            this.$set(this, 'nrPages', 0)
            this.$set(this, 'nrItems', 0)
          }
          this.closeSearch()
          setTimeout(() => {
            this.loading = false
          }, 500)
        })
    },
    dettaglio: function (row) {
      this.loading = true
      this.$http.get('trasferte/' + this.$store.state.country + '/dettaglio', {
        params: {
          idTrasferta: row.idTrasferta,
          pag_action: 'BEGIN',
          pag_from: '1',
          pag_for: '30',
          pag_order: 'DD'
        }
      })
        .then(response => {
          if (response.body.rc === 0) {
            this.dettaglioTrasferta = response.body.data
            this.showModalDettaglio = true
          } else {
            this.$message({
              showClose: true,
              message: response.body.msg[0].msgTxt,
              type: 'error',
              duration: process.env.duration
            })
          }
          this.loading = false
        })
    },
    elimina: function (row) {
      let _this = this
      this.$confirm(this.$i18n.t('trasferte.msg.confDelTrasferta'), this.$i18n.t('trasferte.msg.info'), {
        confirmButtonText: this.$i18n.t('btn.conferma').toUpperCase(),
        cancelButtonText: this.$i18n.t('btn.annulla'),
        type: 'info',
        callback: function (action) {
          if (action === 'confirm') {
            _this.loading = true
            let obj = {
              'operazione': '*DEL',
              'idTrasferta': row.idTrasferta,
              'statoAvanz': row.statoAvanz
            }
            _this.$http.post('trasferte/' + _this.$store.state.country + '/trasferta', obj)
              .then(response => {
                if (response.body.rc === 0) {
                  _this.ricerca()
                } else {
                  _this.$message({
                    showClose: true,
                    message: response.body.msg[0].msgTxt,
                    type: 'error',
                    duration: process.env.duration
                  })
                }
                _this.loading = false
              })
          } else {
            _this.$message({
              showClose: true,
              message: _this.$i18n.t('trasferte.msg.abort'),
              type: 'info',
              duration: process.env.duration
            })
          }
        }
      })
    },
    copia: function (row) {
      row = JSON.parse(JSON.stringify(row))
      this.$set(this.trasferta, 'giorno', '')
      this.$set(this.trasferta, 'tipoTrasferta', row.tipoTrasferta)
      this.$set(this.trasferta, 'oraIni', row.oraDal)
      this.$set(this.trasferta, 'oraFin', row.oraAl)
      this.$set(this.trasferta, 'oreTrasferta', row.oreTrasferta)
      this.$set(this.trasferta, 'contatti', row.contatti)
      this.$set(
        this.trasferta,
        'notaDip',
        row && row.notaDip
          ? row.notaDip.split("\\n").join("\n")
          : ''
      )
      //this.$set(this.trasferta, 'notaDip', row.notaDip.split("\\n").join("\n"))

      this.$set(this, 'tbl_mail', [])
      this.$set(this, 'select_mail', '')
      //this.$set(this, 'manualNome', '')
      this.$set(this, 'manualMail', '')

      this.trasferta.idTrasferta = row.idTrasferta
      this.showModalCopia = true
    },
    incolla: function () {
      let obj = {
        'idTrasferta': this.trasferta.idTrasferta,
        'dataDal': this.trasferta.giorno,
        //'perRif': this.trasferta.perRif,
        'notaDip': this.trasferta.notaDip,
        'contatti': this.trasferta.contatti
      }
      this.$http.post('trasferte/' + this.$store.state.country + '/copia', obj)
        .then(response => {
          if (response.body.rc === 0) {
            this.showModalCopia = false
            this.$router.push({ name: 'DettaglioTrasferta', params: { id: response.body.attrib.idTrasferta } })
          } else {
            this.$message({
              showClose: true,
              message: response.body.msg[0].msgTxt,
              type: 'error',
              duration: process.env.duration
            })
          }
          this.loading = false
        })
    },
    add: function (row) {
      console.log(JSON.stringify(row))
      row = JSON.parse(JSON.stringify(row))
      this.flagDestinazioniEstere = false
      this.$set(this, 'trasferta', {})
      this.$set(this.trasferta, 'tipoTrasferta', row !== null ? row.tipoTrasferta : 'GIO')
      this.$set(this.trasferta, 'dataDal', '')
      this.$set(this.trasferta, 'dataAl', '')
      this.$set(this.trasferta, 'oraIni', '')
      this.$set(this.trasferta, 'oraFin', '')
      this.$set(this.trasferta, 'oreTrasferta', '')
      this.$set(this.trasferta, 'partenza', row !== null ? row.provenienza : '')

      this.$set(this.trasferta, 'desCustom', row !== null ? (row.desMan === undefined ? false : true) : false)
      this.$set(this.trasferta, 'destinazione', row !== null ? (row.desMan === undefined ? row.destinazione : row.desMan) : '')
      //this.$set(this.trasferta, 'desMan', row !== null ? (row.desMan === undefined ? '' : row.desMan) : '')
      this.$set(this.trasferta, 'seEstero', row !== null ? (row.seEstero === undefined ? false : (row.seEstero ? 'si' : 'no')) : false)
      this.$set(this, 'flagDestinazioniEstere', row !== null ? (row.desMan === undefined ? false : true) : false)

      this.$set(this.trasferta, 'socFat', row !== null ? row.cliente : '')
      if (row !== null)
        this.loadUffRep(row.cliente)
      this.$set(this.trasferta, 'uffRep', row !== null ? row.ufficio : '')
      //this.$set(this.trasferta, 'perRif', row !== null ? row.perRif : '')
      //this.$set(this.trasferta, 'notaDip', row !== null ? row.notaDip.split("\\n").join("\n") : '')
      this.$set(
        this.trasferta,
        'notaDip',
        row && row.notaDip
          ? row.notaDip.split("\\n").join("\n")
          : ''
      )
      this.$set(this.trasferta, 'checkedMensa', '')
      this.$set(this.trasferta, 'checkedAlloggio', '')
      this.$set(this.trasferta, 'contatti', row !== null ? row.contatti : [])
      this.$set(this, 'tbl_mail', [])
      this.$set(this, 'select_mail', '')
      // this.$set(this, 'manualNome', '')
      this.$set(this, 'manualMail', '')

      this.showModalNew = true
    },
    salva: function () {
      console.log(JSON.stringify(this.trasferta))
      if (
        (this.trasferta.tipoTrasferta === 'GIO' &&
          (!this.trasferta.periodo || this.trasferta.periodo.length !== 2)
        ) ||
        (this.trasferta.tipoTrasferta === 'ORE' &&
          !this.trasferta.dataDal
        )
      ) {
        this.$message({
          showClose: true,
          message: this.$i18n.t('trasferte.msg.errorNoPeriodo'),
          type: 'error',
          duration: process.env.duration
        })
      } else {
        this.loading = true
        let boolDest = false
        for (let dest in this.tbl_genSta) {
          if (this.tbl_genSta[dest].id === this.trasferta.destinazione) {
            boolDest = true
            break
          }
        }
        let obj = {
          'operazione': '*ADD',
          'tipoTrasferta' : this.trasferta.tipoTrasferta,
          'dataDal': this.trasferta.tipoTrasferta === 'ORE' ? this.trasferta.dataDal : this.trasferta.periodo[0],
          'dataAl': this.trasferta.tipoTrasferta === 'ORE' ? this.trasferta.dataDal : this.trasferta.periodo[1],
          'oraDal': this.trasferta.tipoTrasferta === 'ORE' ? this.trasferta.oraIni : '',
          'oraAl': this.trasferta.tipoTrasferta === 'ORE' ? this.trasferta.oraFin : '',
          'oreTrasferta': this.trasferta.oreTrasferta,
          'provenienza': this.trasferta.partenza,
          'destinazione': boolDest ? this.trasferta.destinazione : undefined,
          'seEstero': boolDest ? undefined : (this.trasferta.seEstero ? 'si' : 'no'),
          'desMan': boolDest ? undefined : this.trasferta.destinazione,
          'cliente': this.trasferta.socFat,
          'ufficio': this.trasferta.uffRep,
          //'perRif': this.trasferta.perRif,
          'notaDip': this.trasferta.notaDip,
          'checkMensa': this.trasferta.checkedMensa ? 'si' : 'no',
          'notaMensa': this.trasferta.notaMensa,
          'checkAlloggio': this.trasferta.tipoTrasferta === 'ORE' ? 'no' : (this.trasferta.checkedAlloggio ? 'si' : 'no'),
          'notaAlloggio': this.trasferta.tipoTrasferta === 'ORE' ? '' : this.trasferta.notaAlloggio,
          'statoAvanz': '0',
          'contatti': this.trasferta.contatti
        }
        this.$http.post('trasferte/' + this.$store.state.country + '/trasferta', obj)
          .then(response => {
            if (response.body.rc === 0) {
              this.$message({
                showClose: true,
                message: response.body.msg[0].msgTxt,
                type: 'success',
                duration: process.env.duration
              })
              this.showModalNew = false
              this.$router.push({ name: 'DettaglioTrasferta', params: { id: response.body.attrib.idTrasferta } })
            } else {
              this.$message({
                showClose: true,
                message: response.body.msg[0].msgTxt,
                type: 'error',
                duration: process.env.duration
              })
            }
            this.loading = false
          })
      }
    },
    changePage: function (page) {
      this.currentPage = page
      this.ricerca(false)
    },
    /*  Viene richiamata quando l'utente clicca sulle frecce di ordinamento della tabella. Setta il codice di ordinamento corrispondente
     *  e richiama il servizio di ricerca con questo codice
     */
    sortChange: function ({ column, prop, order }) {
      if (prop === 'dataIn') {
        if (order === 'ascending') {
          this.ordine = 'DA'
        } else if (order === 'descending') {
          this.ordine = 'DD'
        }
      } else if (prop === 'dataFin') {
        if (order === 'ascending') {
          this.ordine = 'AA'
        } else if (order === 'descending') {
          this.ordine = 'AD'
        }
      } else {
        this.ordine = 'DD'
      }
      this.ricerca(true)
    },
    dettTrasferta: function (row, event, column) {
      this.$router.push({ name: 'DettaglioTrasferta', params: { id: row.idTrasferta } })
    },
    getStatoIcon: function (stato) {
      switch (stato) {
        case '0':
          return 'riv-save2'
        case '1':
        case '2':
        case '3':
          return 'riv-user'
        case '4':
          return 'riv-alloggio'
        case '7':
          return 'elm-chiudi'
        default:
          return ''
      }
    },
    getStatoIcon_dett: function (stato) {
      switch (stato) {
        case '0':
        case '1':
        case '2':
        case '3':
        case '4':
          return 'riv-circle'
        default:
          return ''
      }
    },
    getStatoClass: function (record) {
      switch (record.statoAvanz) {
        case '0':
          return 'status-saved'
        case '1':
          return 'status-send'
        case '2':
          return 'status-rejected'
        case '3':
          return 'status-approved'
        case '4':
          if ((record.statoAlloggio === undefined || record.statoAlloggio === '' || record.statoAlloggio === '3') &&
            (record.statoMensa === undefined || record.statoMensa === '' || record.statoMensa === '3') &&
            (record.statoBiglietti === undefined || record.statoBiglietti === '' || record.statoBiglietti === '3') &&
            (record.statoTrasporti === undefined || record.statoTrasporti === '' || record.statoTrasporti === '3') &&
            (record.statoAutoAz === undefined || record.statoAutoAz === '' || record.statoAutoAz === '3')) {
            return 'status-approved'
          } else {
            return 'status-send'
          }
        case '7':
          return 'status-delete'
          break
        default:
          return ''
          break
      }
    },
    getStatoClass_dett: function (stato) {
      switch (stato) {
        case '0':
          return 'status-saved'
        case '1':
          return 'status-send'
        case '2':
          return 'status-rejected'
        case '3':
          return 'status-approved'
        case '4':
          return 'status-send'
        default:
          return ''
      }
    },
    getStatoDes: function (record) {
      switch (record.statoAvanz) {
        case '4':
          if ((record.statoAlloggio === undefined || record.statoAlloggio === '' || record.statoAlloggio === '3') &&
            (record.statoMensa === undefined || record.statoMensa === '' || record.statoMensa === '3') &&
            (record.statoBiglietti === undefined || record.statoBiglietti === '' || record.statoBiglietti === '3') &&
            (record.statoTrasporti === undefined || record.statoTrasporti === '' || record.statoTrasporti === '3') &&
            (record.statoAutoAz === undefined || record.statoAutoAz === '' || record.statoAutoAz === '3')) {
            return 'status.3'
          } else {
            return 'status.' + record.statoAvanz
          }
        default:
          return 'status.' + record.statoAvanz
          break
      }
    },
    changeDestinazione: function () {
      let custom = true
      for (let dest in this.tbl_genSta) {
        if (this.tbl_genSta[dest].id === this.trasferta.destinazione) {
          custom = false
          break
        }
      }
      this.flagDestinazioniEstere = custom ? true : false
      this.$set(this.trasferta, 'seEstero', false)
    },
    listEmail: function (val) {
      if (val.length >= 3) {
        //this.loadingDocs = true
        this.$set(this, 'tbl_mail', [])
        var obj = {
          params: {
            searchString: val,
            mailNotNull: '1'
          }
        }
        this.$http.get('{SPURL}/api/Emails', obj)
          .then(response => {
            if (response.body.rc === 0) {
              this.$set(this, 'tbl_mail', response.body.data === null ? [] : response.body.data)
            } else {
              this.$message({
                showClose: true,
                message: this.$i18n.t('documenti.msgSP.' + errCode),
                type: 'error',
                duration: process.env.duration
              })
              this.$set(this, 'tbl_mail', [])
            }
          })
      }
    },
    selectEmail: function (mail) {
      let obj = {
        nome: '', //val.Surname + ' ' + val.Name,
        mail: mail
      }
      this.trasferta.contatti.push(obj)
      this.select_mail = ''
    },
    changeInput: function (tipo) {
        /*if (tipo === 'nome' && this.manualNome.length >= 1 && !this.check.manualNome) {
          this.check.manualNome = true
        } else*/ if (tipo === 'mail' && this.manualMail.length >= 1 && !this.check.manualMail) {
        this.check.manualMail = true
      }
    },
    addEmail: function (val) {
      if (this.manualMail !== '') {
        this.trasferta.contatti.push(val)
        //this.manualNome = ''
        this.manualMail = ''
      } else {
        //this.check.manualNome = this.manualNome === '' ? false : true
        this.check.manualMail = this.manualMail === '' ? false : true
      }
    },
    handleClose(tag) {
      this.trasferta.contatti.splice(this.trasferta.contatti.indexOf(tag), 1);
    },
    formatPeriodo: function(row) {
      if (row.tipoTrasferta === 'GIO' && row.dataDal !== '' && row.dataAl) {
        return (row.dataDal.substr(6, 2) + '/' + row.dataDal.substr(4, 2) + '/' + row.dataDal.substr(0, 4)) + ' - ' +
          (row.dataAl.substr(6, 2) + '/' + row.dataAl.substr(4, 2) + '/' + row.dataAl.substr(0, 4))
      } else  if (row.tipoTrasferta === 'ORE' && row.dataDal !== '') {
        return (row.dataDal.substr(6, 2) + '/' + row.dataDal.substr(4, 2) + '/' + row.dataDal.substr(0, 4)) +
        ' (' + row.oraDal + ' - ' + row.oraAl + ')'
      }
    },
    changeOre: function () {
      if (this.trasferta.tipoTrasferta === 'ORE' && this.trasferta.oraIni !== '' && this.trasferta.oraFin !== '') {
        var startTime = moment(this.trasferta.oraIni, 'HH:mm');
        var endTime = moment(this.trasferta.oraFin, 'HH:mm');

        // calculate total duration
        var duration = moment.duration(endTime.diff(startTime));

        // duration in hours
        var hours = parseInt(duration.asHours());

        if (hours < 10) {
          hours = '0' + hours
        }
        var minutes = parseInt(duration.asMinutes()) % 60;
        if (minutes < 10) {
          minutes = '0' + minutes
        }
        // duration in minutes
        console.log(hours + ':' + minutes)
        this.$set(this.trasferta, 'oreTrasferta', hours + ':' + minutes)
      }
    },
  }
}
</script>

<style lang="less">
@import "../../assets/less/general.less";

.icona {
  text-align: center !important;
}

.riepilogo-trasferte {
  height: 100%;

  .table-trasferte {
    margin-top: 10px;
    // WEB-header (56px) - WEB-title (50px) WEB-Action (50px) WEB-paginator (60px)
    height: calc(100vh - 56px - 50px - 50px - 60px - 5px);
  }
}

.modal-body {
  .elemento {
    margin-bottom: 10px;

    .my-label {
      height: 22px;
      line-height: 23px;

      .el-checkbox {
        float: right;
        margin-bottom: 0px;

        //margin-top: 10px;
        .el-checkbox__inner {
          border-radius: 0px;
        }

        &.is-checked {
          .el-checkbox__inner {
            background-color: @greenRiva;
            border-color: @greenRiva;
          }
        }
      }
    }

    .my-value {
      height: 100%;

      .dt-picker {
        //width: 49.5%;

        .el-input__inner {
          padding-left: 30px !important;
        }

        .el-input__prefix {
          left: 0px;

          .el-input__icon {
            line-height: 22px;
            width: 17px;
          }
        }

        .el-input__suffix {
          .el-input__icon {
            line-height: 22px;
            width: 17px;
          }
        }

        &.time {
          width: 100px;
        }
      }

      .el-input {
        &.is-disabled {
          .el-input__inner {
            border: none;
          }
        }

        .el-input__inner {
          border: none;
          border-bottom: 1px solid #dcdfe6;
          border-radius: 0px;
          height: 22px;
          padding-left: 0px;
          line-height: 0px;
          .set-font(@size: 14px);
        }

        .el-input__suffix {
          .el-input__icon {
            line-height: 22px;
            width: 17px;
          }
        }
      }

      .el-select {
        height: 22px;
        width: 100%;

        .el-input {
          height: 22px;

          .el-input__inner {
            border: none;
            border-bottom: 1px solid #dcdfe6;
            border-radius: 0px;
            height: 22px !important;
            padding-left: 0px;
            .set-font(@size: 14px);
          }
        }
      }

      .el-textarea {
        .el-textarea__inner {
          border-radius: 0px;
          padding-left: 5px;
          line-height: 22px;
        }

        .el-textarea__inner:focus {
          border-color: @greenRiva;
        }
      }

      .el-range-editor {
        width: 100%;

        &.el-input__inner {
          border: 0;
          border-bottom: 1px solid #dcdfe6;
          border-radius: 0px;
          height: 22px;
          padding-left: 0px;
          padding-right: 0px;
          line-height: 0px;
          .set-font(@size: 14px);
          color: #007c74;
        }

        .el-input__icon {
          line-height: 16px;
          width: 28px;
        }

        .el-range-input {
          color: #007c74;
        }

        .el-range-separator {
          color: @grayMedium;
          line-height: 18px;
          width: auto;
        }
      }

      .el-checkbox {
        float: right;
        margin-bottom: 0px;

        //margin-top: 10px;
        .el-checkbox__inner {
          border-radius: 0px;
        }

        &.is-checked {
          .el-checkbox__inner {
            background-color: @greenRiva;
            border-color: @greenRiva;
          }
        }
      }
    }
  }

}

.el-input.input-error {
  .el-input__inner {
    border-bottom: 1px solid red !important;
  }
}

.status-send {
  color: @orangeMedium
}

.status-approved {
  color: @greenApproved
}

.status-rejected,
.status-delete {
  color: #f44336
}

.check-estera {
  .check-estera-label {
    height: 22px;
    line-height: 23px;
    font-style: italic;
    color: @greenRiva;
    padding-left: 15px;
    padding-right: 15px;
  }

  .el-checkbox {
    margin-bottom: 0px;
    padding: 0;
    line-height: 22px;
    height: 22px;

    .el-checkbox__input {
      border-color: @greenRiva;

      &.is-checked {
        .el-checkbox__inner {
          background-color: @greenRiva;
          border-color: @greenRiva;
        }
      }
    }

    .el-checkbox__inner:hover {
      border-color: @greenRiva;
    }
  }
}

.add {
  //position: fixed;
  float: right;
  //right: 20px;
  //bottom: 20px;
  color: #FF791A;
}
</style>



// WEBPACK FOOTER //
// src/components/Trasferte/RiepilogoTrasferte.vue